import React, { Component } from "react"
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { PootsyButton } from './DesignFunctions'
import InputsChangeHandler from "./InputsChangeHandler";
import { PootsyTextInput } from './InputsFunctions'
import PootsySelectInput from "./shared/PootsySelectInput";

import * as actions from "../actions/acAccountProfile"


class AccountProfile extends Component {

	componentWillMount = () => {
		this.props.dispatch(actions.processDataChange(this.props.user))
	}

	render() {
		let { t } = this.context

		let { firstName, lastName, phone, secondaryPhone, landlinePhone, sodexoRef } = this.props.data
		let { canSubmit } = this.props.meta

		return(
			<InputsChangeHandler onChange={this.handleFormChanges}>
				<div className="AccountProfiles">
					<div className="account-profile-prompt">
						{t('account_profile_prompt')}
					</div>
					<div className="signup-textinputs">
						{this.renderGenderSelect()}
						<PootsyTextInput
							name="firstName"
							label={t('first_name_input_label')}
							value={firstName}
						/>
						<PootsyTextInput
							name="lastName"
							label={t('last_name_input_label')}
							value={lastName}
						/>
						{this.renderLanguageSelect()}
					</div>
					<div className="account-profile-prompt">
						{t('account_profile_contact_prompt')}
					</div>
					<div className="signup-textinputs">
						<PootsyTextInput
							name="phone"
							label={t('telephone_input_label')}
							value={phone}
						/>
						<PootsyTextInput
							name="secondaryPhone"
							label={t('secondary_phone_input_label')}
							value={secondaryPhone}
						/>
						<PootsyTextInput
							name="landlinePhone"
							label={t('landline_phone_input_label')}
							value={landlinePhone}
						/>
					</div>
					<div className="account-profile-prompt">
						{t('account_profile_sodexo_prompt')}
					</div>
					<div className="signup-textinputs">
						<PootsyTextInput
							name="sodexoRef"
							label={t('sodexo_reference_input_label')}
							value={sodexoRef}
						/>
						{this.renderSodexoRegionSelect()}
					</div>
					<PootsyButton text={t('save')}
								  onClick={this.onEditAccountProfileButtonClick}
								  disabled={!canSubmit}
					/>
				</div>
			</InputsChangeHandler>
		)
	}

	renderGenderSelect = () => {

		let { t } = this.context
		let { title } = this.props.data

		let options = [
			{
				value: 'mr',
				label: t('gender_mr')
			},
			{
				value: 'mrs',
				label: t('gender_mrs')
			}
		]

		return (
			<PootsySelectInput options={options}
							   onChange={this.onGenderSelected}
							   label={t('gender')}
							   selectedValue={title}
							   defaultValue={""}
			/>
		)
	}

	renderLanguageSelect = () => {

		let { t } = this.context
		let { lang } = this.props.data

		let options = [
			{
				value: 'fr',
				label: t('language_fr')
			},
			{
				value: 'nl',
				label: t('language_nl')
			}
			,
			{
				value: 'en',
				label: t('language_en')
			}
		]

		return (
			<PootsySelectInput options={options}
							   onChange={this.onLanguageSelected}
							   label={t('language')}
							   selectedValue={lang}
							   defaultValue={''}
			/>
		)
	}

	renderSodexoRegionSelect = () => {

		let { t } = this.context
		let { sodexoRegion } = this.props.data

		let options = [
			{
				value: 'Bruxelles',
				label: t('sodexo_region_bxl')
			},
			{
				value: 'Wallonie',
				label: t('sodexo_region_wal')
			},
			{
				value: 'Vlaanderen',
				label: t('sodexo_region_vl')
			}
		]

		return (
			<PootsySelectInput options={options}
							   onChange={this.onSodexoRegionSelected}
							   label={t('sodexo_region')}
							   selectedValue={sodexoRegion}
							   defaultValue={''}
			/>
		)
	}

	onGenderSelected = (changes) => {
		this.props.dispatch(actions.processDataChange({ title: changes.value }))
	}

	onLanguageSelected = (changes) => {
		this.props.dispatch(actions.processDataChange({ lang: changes.value }))
	}

	onSodexoRegionSelected = (changes) => {
		this.props.dispatch(actions.processDataChange({ sodexoRegion: changes.value }))
	}

	handleFormChanges = changes => {
		this.props.dispatch(actions.processDataChange(changes))
	}

	onEditAccountProfileButtonClick = () => {
		this.props.dispatch(actions.saveAccountProfile())
	}
}

AccountProfile.contextTypes = { t: PropTypes.func }

const mapStateToProps = state => ({
	user: state.dataReducer.currentUser,
	data: state.dataReducer.accountProfile,
	meta: state.metadataReducer.accountProfile
})

export default connect(mapStateToProps)(AccountProfile);



// WEBPACK FOOTER //
// ./src/components/AccountProfile.js